import React from 'react';
import { Navigate } from 'react-router-dom';
import Seo from '@/components/Seo';
import Breadcrumbs from '@/components/Breadcrumbs';
import Reveal from '@/components/Reveal';

const CONTENT = {
  '/privacy-policy': {
    title: 'Privacy Policy',
    h1: 'Privacy Policy',
    blocks: [
      { h: 'What we collect', p: 'When you submit an enquiry on this website, we collect your name, mobile number, email address (optional) and configuration preference, along with technical context such as the page you enquired from and campaign parameters (UTM tags).' },
      { h: 'How we use it', p: 'Your details are used solely to respond to your enquiry about Provident Palm Vista — to share pricing, floor plans, brochures, availability and to arrange site visits. We may contact you via phone, WhatsApp, SMS or email.' },
      { h: 'Sharing', p: 'Your information may be shared with the authorised sales team for the project for the purpose of servicing your enquiry. We do not sell your personal information to third parties.' },
      { h: 'Your choices', p: 'You may request correction or deletion of your submitted details at any time by contacting us on WhatsApp or call at +91 88798 56585.' },
    ],
  },
  '/terms-conditions': {
    title: 'Terms & Conditions',
    h1: 'Terms & Conditions',
    blocks: [
      { h: 'Nature of this website', p: 'This website is an independent information resource about Provident Palm Vista, Shilphata. It is not the official website of Provident Housing or Puravankara Limited.' },
      { h: 'Accuracy of information', p: 'Content is compiled from official project material and is provided in good faith. Prices, offers, availability, specifications and plans are subject to change without notice and must be verified with the authorised sales representative before making any decision.' },
      { h: 'No offer or warranty', p: 'Nothing on this website constitutes an offer, warranty or commitment. All purchases are governed solely by the agreement for sale and applicable RERA records.' },
      { h: 'Intellectual property', p: 'Project names, marks and documents referenced belong to their respective owners and are used here for information purposes only.' },
    ],
  },
  '/disclaimer': {
    title: 'Disclaimer',
    h1: 'Disclaimer',
    blocks: [
      { h: 'General disclaimer', p: 'Project information, specifications, plans, amenities, images, dimensions, pricing and availability are subject to change and should be independently verified with the authorised sales representative. Images and visual representations may be artistic or illustrative. Please refer to the applicable project documentation and agreement for definitive details.' },
      { h: 'RERA', p: 'Provident Palm Vista is registered under MahaRERA with wing-wise registrations (B1 – P51700025841, B2 – P51700025839, C1 – P51700025840, C2 – P51700025864, D1 – P51700025844, D2 – P51700025854, D3 – P51700025849, D4 – P51700025842). Verify at maharera.mahaonline.gov.in.' },
      { h: 'Infrastructure references', p: 'References to upcoming infrastructure (metro lines, corridors, airport) are based on project material and public information. Historical expected dates quoted in earlier material should not be treated as current facts; verify present status independently.' },
    ],
  },
};

const Legal = ({ pageKey }) => {
  const page = CONTENT[pageKey];
  if (!page) return <Navigate to="/" replace />;
  return (
    <>
      <Seo title={`${page.title} | Provident Palm Vista Shilphata`} description={`${page.title} for providentpalmvistashilphata.com — an independent information website about Provident Palm Vista Shilphata.`} path={pageKey} />
      <section className="pt-28 md:pt-36 pb-16 md:pb-24 bg-ivory min-h-[70vh]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Breadcrumbs items={[{ name: page.title }]} />
          <Reveal>
            <h1 className="font-display text-4xl sm:text-5xl font-medium text-palm leading-[1.08] tracking-tight">{page.h1}</h1>
          </Reveal>
          <div className="space-y-8 mt-10">
            {page.blocks.map((b) => (
              <Reveal key={b.h}>
                <h2 className="font-display text-xl sm:text-2xl font-medium text-palm">{b.h}</h2>
                <p className="text-sm sm:text-[15px] text-ink/75 mt-2 leading-relaxed">{b.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Legal;
